import { Component, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf } from '@angular/common';

interface CheckboxCellValues {
	disabled: boolean;
	showValue: boolean;

	isChecked(params: ICellRendererParams<unknown, unknown>): boolean;
}

@Component({
	selector: 'copo-checkbox-cell',
	templateUrl: './checkbox-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatCheckboxModule, FormsModule]
})
export class CheckboxCellComponent implements ICellRendererAngularComp {
	params?: ICellRendererParams<unknown, unknown>;

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<unknown, unknown>) {
		this.setParams(params);
	}

	refresh(params: ICellRendererParams<unknown, unknown>) {
		this.setParams(params);
		this.changeDetectorRef.detectChanges();
		return true;
	}

	isChecked() {
		if (this.params?.colDef) {
			return (<CheckboxCellValues> this.params.colDef.cellRendererParams).isChecked(this.params);
		}
		return false;
	}

	isDisabled() {
		if (this.params?.colDef) {
			return (<CheckboxCellValues> this.params.colDef.cellRendererParams).disabled;
		}
		return false;
	}

	getValue() {
		if (this.params?.colDef === undefined || this.params.getValue === undefined) {
			return undefined;
		}
		if ((<CheckboxCellValues> this.params.colDef.cellRendererParams).showValue) {
			return <string> this.params.getValue();
		}
		return undefined;
	}

	private setParams(params: ICellRendererParams<unknown, unknown>) {
		this.params = params;
	}
}
